import React, { ReactNode } from 'react';
import { useStyles } from './styles/carousel-dots.styles';
import { CarouselPage } from './types';
import CarouselDot from './CarouselDot';
import Box from '@material-ui/core/Box';

interface CarouselDotsProps {
  pages: CarouselPage[];
  textBelowCarousel: ReactNode[];
  setStep: (index: number) => void;
  step: number;
}

export default function CarouselDots({
  pages,
  textBelowCarousel,
  setStep,
  step,
}: CarouselDotsProps) {
  const classes = useStyles();

  const description = textBelowCarousel[step];

  return (
    <>
      <Box
        display="flex"
        alignContent="center"
        justifyContent="center"
        className={classes.dots}
      >
        {pages.map((page, i) => (
          <CarouselDot {...{ setStep, index: i, step }} key={i} />
        ))}
      </Box>
      {description && (
        <div className={classes.textBelowDots}>{description}</div>
      )}
    </>
  );
}
